var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSm01LeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3128 3.4107V2.20289C11.3128 2.0982 11.1925 2.04039 11.1113 2.10445L4.06752 7.60601C4.00767 7.65256 3.95924 7.71215 3.92593 7.78025C3.89262 7.84836 3.87531 7.92317 3.87531 7.99898C3.87531 8.0748 3.89262 8.14961 3.92593 8.21771C3.95924 8.28582 4.00767 8.34541 4.06752 8.39195L11.1113 13.8935C11.1941 13.9576 11.3128 13.8998 11.3128 13.7951V12.5873C11.3128 12.5107 11.2769 12.4373 11.2175 12.3904L5.59252 7.99976L11.2175 3.60758C11.2769 3.5607 11.3128 3.48726 11.3128 3.4107V3.4107Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSm01LeftArrow);
export default __webpack_public_path__ + "static/media/SM01-left-arrow.1d85e214cc161bfd53993857fb7c944a.svg";
export { ForwardRef as ReactComponent };